import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import DigitalSkeleton from './AdSectionSkeleton';
import ErrorState from '../ErrorState/ErrorState';
import { useCachedFetch } from '../../hooks/useCachedFetch';
import LocalizedNavLink from '../../hooks/LocalizedNavLink';
import { AnimatedOnScroll } from '../AnimatedOnScroll';
import './AdSection.scss';

const AdSection = ({ page }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const { data: servicesData, loading, error, refetch } = useCachedFetch('/data/locales/services.json');

  const handleRetry = useCallback(() => {
    refetch();
  }, [refetch]);

  if (loading) return <DigitalSkeleton />;
  if (error) return <ErrorState onRetry={handleRetry} />;

  const pageData = servicesData?.pages?.[page];
  if (!pageData) return <ErrorState onRetry={handleRetry} />;

  const { accent, mainTitle, subtitle, servicesList } = pageData;

  return (
    <div className="home__ad__section">
      <div className="left__side__ad__section">
        <div className="ad__content">
          <AnimatedOnScroll animation="fade-up" delay={0}>
            <p className="ad__accent">{accent?.[currentLang] || accent?.en || ''}</p>
          </AnimatedOnScroll>
          <AnimatedOnScroll animation="fade-up" delay={100}>
            <h4 className="ad__title">{mainTitle?.[currentLang] || mainTitle?.en || ''}</h4>
          </AnimatedOnScroll>
          <AnimatedOnScroll animation="fade-up" delay={200}>
            <h5 className="ad__subtitle">{subtitle?.[currentLang] || subtitle?.en || ''}</h5>
          </AnimatedOnScroll>
        </div>
      </div>
      <div className="right__side__ad__section">
        {servicesList?.map((service, index) => (
          <AnimatedOnScroll
            key={index}
            animation="fade-up"
            delay={index * 100}
            duration={600}
            className="ad__services__links__item"
          >
            <LocalizedNavLink
              to={`/marketing-and-advertising${service.link}`}
              className="ad__links__item"
            >
              {(service.title?.[currentLang] || service.title?.en || []).map((line, lineIndex) => (
                <h3 key={lineIndex} className="ad__title__item">{line}</h3>
              ))}
            </LocalizedNavLink>
            <p className="ad__text__item">
              {service.description?.[currentLang] || service.description?.en || ''}
            </p>
          </AnimatedOnScroll>
        ))}
      </div>
    </div>
  );
};

export default AdSection;